import { useRef, useState } from 'react';
import { api } from '../../lib/api';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Image as ImgIcon, Loader2, Upload, Link as LinkIcon, X } from 'lucide-react';
import { toast } from 'sonner';

export const ImageUploader = ({ value, onChange, label = 'Image' }) => {
  const fileRef = useRef(null);
  const [uploading, setUploading] = useState(false);
  const [mode, setMode] = useState('url'); // 'url' | 'file'

  const onFile = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setUploading(true);
    try {
      const form = new FormData();
      form.append('file', f);
      const { data } = await api.post('/upload/image', form, { headers: { 'Content-Type': 'multipart/form-data' } });
      onChange(data.url);
      toast.success('Image uploaded');
    } catch (err) { toast.error(err?.response?.data?.detail || 'Upload failed'); } finally { setUploading(false); }
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-1.5">
        <div className="text-sm text-white/85">{label}</div>
        <div className="flex items-center gap-1 text-xs">
          <button type="button" onClick={() => setMode('url')} className={`px-2 py-1 rounded-md ${mode === 'url' ? 'bg-white/10 text-white' : 'text-white/55 hover:text-white'}`}><LinkIcon className="h-3 w-3 inline mr-1" /> URL</button>
          <button type="button" onClick={() => setMode('file')} className={`px-2 py-1 rounded-md ${mode === 'file' ? 'bg-white/10 text-white' : 'text-white/55 hover:text-white'}`}><Upload className="h-3 w-3 inline mr-1" /> Upload</button>
        </div>
      </div>
      <div className="flex items-start gap-3">
        <div className="shrink-0 w-20 h-20 rounded-xl border border-white/12 bg-[#0d223d] overflow-hidden flex items-center justify-center">
          {value ? (
            <img src={value} alt="" className="w-full h-full object-cover" />
          ) : (
            <ImgIcon className="h-6 w-6 text-white/35" />
          )}
        </div>
        <div className="flex-1">
          {mode === 'url' && (
            <Input data-testid="admin-image-url-input" placeholder="https://..." value={value || ''} onChange={(e) => onChange(e.target.value)} className="bg-white/5 border-white/15 text-white placeholder:text-white/35" />
          )}
          {mode === 'file' && (
            <div className="flex items-center gap-2">
              <input ref={fileRef} type="file" accept="image/*" onChange={onFile} className="hidden" />
              <Button type="button" data-testid="admin-image-upload-button" onClick={() => fileRef.current?.click()} variant="outline" className="border-white/15 bg-white/5 text-white hover:bg-white/10 hover:text-white rounded-xl">
                {uploading ? <><Loader2 className="mr-2 h-4 w-4 animate-spin" /> Uploading…</> : <><Upload className="mr-2 h-4 w-4" /> Choose file</>}
              </Button>
              {value && <Button type="button" variant="ghost" size="sm" onClick={() => onChange('')} className="text-white/55 hover:text-white"><X className="h-4 w-4" /></Button>}
              <span className="text-[11px] text-white/45">Max 6 MB</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
